module.exports = __webpack_public_path__ + "static/img/fcc_banner2-1.c5c146b8.png";